@if (form()) { @if(disabled()){
<div [innerHTML]="form().get(controlName())?.value | userReplace"></div>
} @else{
<form
  class="form richtTextBody"
  [formGroup]="form()">
  <angular-editor
    #editor
    [formControlName]="controlName()"
    [config]="editorConfig"></angular-editor>
</form>
} }
